import { Flex, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext } from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import frLocale from '@fullcalendar/core/locales/fr'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import AvailableNowCard from '../AvailableNowCard'
import CreateEventCard from '../../EventsPage/CreateEventCard'
import CustModal from '../../../Common/CustModal'
import AppointmentCreationForm from '../../AppointmentsPage/AppointmentCreationForm'
import LoginContext from '../../LoginContext'

dayjs.extend(weekday)
dayjs.extend(localeData)

export default function BoxCalendarPageXL ({
  box, appointmentModalVisible, loading, appointmentForm, setAppointmentModalVisible,
  onAdd, rangeDisable, boxAvailableNow, setRangeDisable, periods,
  loadCalendarData, day, businessHours, events, renderEventContent, selected, minHour, maxHour, okButtonProps
}) {
  return (
    <>
      {box && <>
        <CustModal
          open={appointmentModalVisible}
          setOpen={setAppointmentModalVisible}
          title={t('Admin.BoxCalendar.popupTitle')}
          confirmLoading={loading}
          maskClosable={true}
          onOk={appointmentForm.submit}
          okButtonProps={okButtonProps}
        >
          <Spin spinning={loading}>
            <AppointmentCreationForm form={appointmentForm} onFinish={onAdd} rangeDisable={rangeDisable} />
          </Spin>
        </CustModal>
        <Flex vertical style={{ padding: '1em', backgroundColor: 'white' }}>
          <Flex>
            {
              boxAvailableNow && <AvailableNowCard setModalVisible={setAppointmentModalVisible} setRangeDisable={setRangeDisable} form={appointmentForm} appointmentDuration={box.appointment_duration} />
            }
            <CreateEventCard box={box} />
          </Flex>
          <FullCalendar
            height="auto"
            selectable={true}
            plugins={[timeGridPlugin, interactionPlugin]}
            firstDay={dayjs().day() - 1}
            initialDate={day || dayjs().format('YYYY-MM-DD')}
            initialView="timeGridWeek"
            slotDuration="00:30:00"
            locale={frLocale}
            allDaySlot={false}
            displayEventTime={false}
            businessHours={businessHours(periods)}
            events={events}
            eventContent={renderEventContent}
            datesSet={loadCalendarData}
            select={(info) => selected(info)}
            eventOrder={'type'}
            slotMinTime={minHour + ':00:00'}
            slotMaxTime={maxHour + ':00:00'}
            nowIndicator={true}
          />
        </Flex>
      </>
      }
    </>
  )
}
